import request from '@/utils/request'

// 查询查询故障报告列表
export function listFaultReport(query) {
  return request({
    url: '/system/faultReport/list',
    method: 'get',
    params: query
  })
}

// 查询查询故障报告详细
export function getFaultReport(id) {
  return request({
    url: '/system/faultReport/' + id,
    method: 'get'
  })
}

// 新增查询故障报告
export function addFaultReport(data) {
  return request({
    url: '/system/faultReport',
    method: 'post',
    data: data
  })
}

// 修改查询故障报告
export function updateFaultReport(data) {
  return request({
    url: '/system/faultReport',
    method: 'put',
    data: data
  })
}

// 删除查询故障报告
export function delFaultReport(id) {
  return request({
    url: '/system/faultReport/' + id,
    method: 'delete'
  })
}

// 导出查询故障报告
export function exportFaultReport(query) {
  return request({
    url: '/system/faultReport/export',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/faultReport.js